/**
 * Stable error codes for actor-authorization failures, shared between
 * backend (thrown via ForbiddenError) and frontend (matched against the
 * `code` field of a 403 response body to decide UX behavior).
 *
 * Keep string values stable — they form part of the wire contract.
 */
export const ActorAuthorizationErrorCodes = {
  /**
   * The authenticated actor has no participant record in the event they're
   * acting on (e.g. host/admin/owner viewing participant-scoped data).
   * Frontend uses this to render an empty state for participant-only
   * endpoints without surfacing an auth-revocation error.
   */
  ACTOR_NOT_PARTICIPANT: "ACTOR_NOT_PARTICIPANT",
  /**
   * No authenticated user: the request has no session, or its session ended
   * or is invalid.
   */
  USER_ACTIONS_FORBIDDEN: "USER_ACTIONS_FORBIDDEN",
} as const;
